import requestAction from '../../utils/requestAction'

export const fetchCurrentAccountSummary = (params: string) => 
  requestAction('CURRENT_ACCOUNT_SUMMARY', params)(`currentAccounts/summary`, 'GET')
